import { render, staticRenderFns } from "./showTransaction.vue?vue&type=template&id=5d54e8f1&scoped=true&"
import script from "./showTransaction.vue?vue&type=script&lang=js&"
export * from "./showTransaction.vue?vue&type=script&lang=js&"
import style0 from "./showTransaction.vue?vue&type=style&index=0&id=5d54e8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54e8f1",
  null
  
)

export default component.exports